export const PaymentPaths = {
	Index: {
		route: "/payments",
		path: "/payments",
	},
};
